var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_690_168038",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_690_168038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 19.4253C13.6116 19.8084 13.1489 20 12.6061 20C12.0632 20 11.6005 19.8084 11.218 19.4253L4.55523 12.7879C4.37015 12.6025 4.23135 12.3862 4.13881 12.139C4.04627 11.8918 4 11.6385 4 11.3789V5.96524C4 5.40904 4.18816 4.94245 4.56448 4.56547C4.9408 4.18849 5.40658 4 5.96181 4H11.366C11.6383 4 11.8945 4.05253 12.1347 4.15759C12.3749 4.26265 12.5875 4.40788 12.7726 4.59328L19.4354 11.2306C19.8179 11.6137 20.006 12.0742 19.9999 12.6118C19.9937 13.1495 19.7932 13.6161 19.3984 14.0116L13.9941 19.4253ZM12.6246 18.0533L18.0288 12.6396L11.3627 5.96524H5.96181V11.3789L12.6246 18.0533ZM7.84959 9.19119C8.22489 9.19119 8.54388 9.05961 8.80658 8.79644C9.06929 8.53328 9.20065 8.21373 9.20065 7.83777C9.20065 7.46182 9.06929 7.14227 8.80658 6.87911C8.54388 6.61594 8.22489 6.48436 7.84959 6.48436C7.47429 6.48436 7.15529 6.61594 6.8926 6.87911C6.62989 7.14227 6.49853 7.46182 6.49853 7.83777C6.49853 8.21373 6.62989 8.53328 6.8926 8.79644C7.15529 9.05961 7.47429 9.19119 7.84959 9.19119Z",
    fill: "#ADADAD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a2e6bd32e601234f317d61bbd3bcb6f0.svg";
export { ForwardRef as ReactComponent };